import React, { Component, Fragment} from 'react'
import Theme from "./../../assets/Theme";
import Header from './../../components/Header';
import { connect } from 'react-redux';
import FormMultibuscador from './../../components/FormMultibuscador';
//import Search from './../../components/Search';
import SearchTrainsTickets from '../../forms/SearchTrainsTickets';
import SearchTrainsPasses from './../../forms/SearchTrainsPasses';
import Footer from './../../components/Footer';
import Subscribe from './../../components/Subscribe';
import {FormControl, FormControlLabel, Radio, RadioGroup, Box, Container, Link, Typography } from '@material-ui/core';
// import config from "./../../store/config/config.json";
import { getRestore} from "../../store/actions/index";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert'
class HomePage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tabSearchTypeSelected: 'tickets',
            tabSearchOptionSelected: 'oneway',
            stateError:this.props.location.state?.stateError?true:false
        }
    }

    componentDidMount () {
        this.props.dispatchGetRestore();
    }

    render() {
        const tokenClient = this.props.match.params.token

        let config = require(`./../../store/config/${tokenClient}/config.json`);

        const BgMask = (props) => {
            const preventDefault = (event) => event.preventDefault();
            return (
                <Link href="#" onClick={preventDefault} {...props} >&nbsp;</Link>
            )
        }

        const Alert = (props: AlertProps) => {
            return <MuiAlert  elevation={100}  variant="filled" {...props} />;
        }

        const switchSearchType = (type) => {
            this.setState({tabSearchTypeSelected: type});
        };
        const switchOptionType = (type) => {
            this.setState({tabSearchOptionSelected: type});
        };

        const handleClose = (event?: React.SyntheticEvent, reason?: string) => {

            this.setState((prevState) => ({
                stateError: false,
            }));
        };

        return (
            <Theme>

                <div className={`wrapper wrapper-${config.client.name}`} styles={config.styles}>
                    <Snackbar open={this.state.stateError}   onClose={handleClose}
                            anchorOrigin={{vertical: 'top', horizontal: 'center'}}
                            autoHideDuration={6000}       >
                        <Alert  onClose={handleClose}  severity="error">
                            No se encontraron resultados para su busqueda
                        </Alert>
                    </Snackbar>
                    <Header misReservas={config.misReservas} client={config.client} /* textError={textError} */ header={config.header} tokenClient={tokenClient} isLogin={config.credential.isLogin} />
                    <Box className="search-form-section" component="section" display="flex" alignItems="center" p={1} m={1}>
                        <BgMask className="bgMask" />
                        <div className="page-maxwidth">
                            <Container className="containerWrapperOpcType" maxWidth="xl">
                                <div className="wrapperOpcType">
                                    <h1>{this.state.testState}</h1>
                                    <FormMultibuscador 
                                        items={config.multisearch.items} 
                                        active={config.multisearch.active} 
                                        client={config.client} 
                                        isIframe={config.multisearch.isIframe} 
                                        //switchSearchType={switchSearchType}
                                        //switchOptionType={switchOptionType}
                                        content = {
                                        <Fragment>
                                            
                                            <Typography variant="h4" component={'span'} className='title-search'>Trenes</Typography>
                                            { config.credential.api.tokenPasses && 
                                            <FormControl component="fieldset" className="selectSearchType">
                                                <RadioGroup row aria-label="switchSearchType" name="switchSearchType" defaultValue={this.state.tabSearchTypeSelected} >
                                                    <FormControlLabel className="radioOption" value="tickets" control={<Radio />} label="Tickets" onClick={() =>  switchSearchType('tickets')}/>
                                                    <FormControlLabel className="radioOption" value="passes" control={<Radio  />} label="Pases" onClick={() =>  switchSearchType('passes')}/>
                                                </RadioGroup>
                                            </FormControl>
                                            }
                                            <br />

                                           {/*  {this.state.tabSearchTypeSelected === 'tickets' && 
                                            <FormControl component="fieldset" className="selectOptionType">
                                                <FormLabel component="legend"><span style={{fontWeight: 'normal', marginRight: 5 }}></span> Tipo de Viaje:</FormLabel>
                                                <RadioGroup row aria-label="switchOptionType" name="switchOptionType" defaultValue={this.state.tabSearchOptionSelected} >
                                                    <FormControlLabel className="radioOption" value="oneway" control={<Radio />} label="Sólo Ida" onClick={() =>  switchOptionType('oneway')}/>
                                                    <FormControlLabel className="radioOption" value="roundtrip" control={<Radio  />} label="Ida y Vuelta" onClick={() =>  switchOptionType('roundtrip')}/>
                                                </RadioGroup>
                                            </FormControl>
                                            } */}

                                            

                                          {/*   <br/>   */}        
                                            

                                            <div className="form-multibuscador-search-container">
                                                { this.state.tabSearchTypeSelected === 'tickets'
                                                    ? <SearchTrainsTickets tokenClient={tokenClient} apiToken={config.credential.api.token} apiUrl={config.credential.api.url} user={config.header}  client={config.client}/> 
                                                    : <SearchTrainsPasses tokenClient={tokenClient} apiToken={config.credential.api.tokenPasses} apiUrl={config.credential.api.url} user={config.header}  client={config.client}/> 
                                                }
                                            </div>
                                        </Fragment>
                                    } />
                                </div>
                            </Container>
                        </div>
                    </Box>
                    {config.footer.subscribe?<Subscribe />:''}
                    <Footer data={config.footer} client={config.client} />
                </div>
            </Theme>
        )
    }
}

const mapStateToProps = reducers => {
    return reducers.loginReducer
};
const mapDispatchToProps = dispatch => {
    return {
        dispatchGetRestore: () =>
            dispatch(
                getRestore()
            )
    };
}
export default connect(mapStateToProps,mapDispatchToProps)(HomePage)

